import { render } from "./commandes.vue?vue&type=template&id=c0512cdc"
import script from "./commandes.vue?vue&type=script&lang=ts"
export * from "./commandes.vue?vue&type=script&lang=ts"
script.render = render

export default script